import BaseService from './BaseService'

/** @returns {string} */
export function newSuspendedSaleIdempotencyKey () {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `ss-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
}

class SuspendedSalesService extends BaseService {
  constructor () {
    super('')
  }

  /**
   * @param {number|string} salesRegisterId
   */
  async listForRegister (salesRegisterId) {
    return this.customRequest('get', '/suspended-sales', {
      sales_register_id: salesRegisterId
    })
  }

  /**
   * @param {{ sales_register_id: number, base_cart_revision?: number, note?: string|null }} body
   * @param {string} idempotencyKey
   */
  async suspend (body, idempotencyKey) {
    return this.customRequest('post', '/suspended-sales', body, {
      headers: { 'Idempotency-Key': idempotencyKey },
      meta: { silent: true }
    })
  }

  /**
   * @param {number|string} suspendedSaleId
   * @param {{ sales_register_id: number, force_takeover?: boolean }} body
   * @param {string} idempotencyKey
   */
  async resume (suspendedSaleId, body, idempotencyKey) {
    return this.customRequest('post', `/suspended-sales/${suspendedSaleId}/resume`, body, {
      headers: { 'Idempotency-Key': idempotencyKey }
    })
  }

  /**
   * @param {number|string} suspendedSaleId
   * @param {number|string} salesRegisterId
   * @param {{ forceAbandon?: boolean }} [options]
   */
  async abandon (suspendedSaleId, salesRegisterId, options = {}) {
    const params = { sales_register_id: salesRegisterId }
    if (options.forceAbandon) {
      params.force_abandon = 1
    }
    return this.customRequest('delete', `/suspended-sales/${suspendedSaleId}`, null, {
      params
    })
  }

  /**
   * @param {number|string} suspendedSaleId
   * @param {{ sales_register_id: number, note?: string|null }} body
   */
  async updateNote (suspendedSaleId, body) {
    return this.customRequest('patch', `/suspended-sales/${suspendedSaleId}`, body, {
      meta: { silent: true }
    })
  }

  /**
   * CSV export (requires `reports.export`); use {@link report} for JSON.
   * @param {Record<string, string|number|undefined|null>} params
   * @returns {Promise<Blob>}
   */
  async reportCsv (params) {
    return this.customRequest('get', '/reports/suspended-sales', { ...params, export: 'csv' }, { responseType: 'blob' })
  }

  /**
   * @param {Record<string, string|number|undefined|null>} params
   */
  async report (params) {
    return this.customRequest('get', '/reports/suspended-sales', params)
  }
}

export const suspendedSalesService = new SuspendedSalesService()
